var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{staticClass:"iframe-video",class:{
    facebookReel: _vm.socialMediaName(_vm.video) === 'Facebook' && _vm.video.includes('reel/'),
    facebook: _vm.socialMediaName(_vm.video) === 'Facebook' && !_vm.video.includes('reel/'),
    tiktok: _vm.socialMediaName(_vm.video) === 'TikTok',
    instagram: _vm.socialMediaName(_vm.video) === 'Instagram',
  },attrs:{"src":_vm.videoEmbedUrl,"allowfullscreen":"allowfullscreen","frameborder":"0"}})
}
var staticRenderFns = []

export { render, staticRenderFns }